<script lang="ts">
  import PayrollDeductions from '../../components/admin/payroll/PayrollDeductions.svelte';
</script>

<div class="payroll-deductions-page-wrapper">
  <PayrollDeductions />
</div>

<style>
  .payroll-deductions-page-wrapper {
    width: 100%;
    height: 100%;
  }
</style> 